import { useEffect, useState } from "react";
import axios from "axios";
const DEFAULT = {
    maintenance: { enabled: false, title: "", message: "", contact_info: "" },
    popup: null,
};
const POLL_INTERVAL = 60000;
export function useStatus() {
    const [status, setStatus] = useState(DEFAULT);
    async function fetchStatus() {
        try {
            const base = (process.env.API_URL || '') + '/v1';
            const { data } = await axios.get(`${base}/app/status`);
            setStatus(data);
        }
        catch {
            // Never block the app on a failed status check
        }
    }
    useEffect(() => {
        fetchStatus();
        const interval = setInterval(fetchStatus, POLL_INTERVAL);
        return () => clearInterval(interval);
    }, []);
    return status;
}
